import { Box } from '@mui/material';

export default function ScannerOverlay() {
	const cornerSize = 60;
	const cornerThickness = 4;
	const borderColor = '#00FF00';

	const cornerStyle = {
		position: 'absolute' as const,
		width: cornerSize,
		height: cornerSize,
		border: `${cornerThickness}px solid ${borderColor}`,
	};

	return (
		<Box
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '280px',
				height: '280px',
				pointerEvents: 'none',
				zIndex: 10,
			}}
		>
			{/* Top Left */}
			<Box
				sx={{
					...cornerStyle,
					top: 0,
					left: 0,
					borderRight: 'none',
					borderBottom: 'none',
				}}
			/>

			{/* Top Right */}
			<Box
				sx={{
					...cornerStyle,
					top: 0,
					right: 0,
					borderLeft: 'none',
					borderBottom: 'none',
				}}
			/>

			{/* Bottom Left */}
			<Box
				sx={{
					...cornerStyle,
					bottom: 0,
					left: 0,
					borderRight: 'none',
					borderTop: 'none',
				}}
			/>

			{/* Bottom Right */}
			<Box
				sx={{
					...cornerStyle,
					bottom: 0,
					right: 0,
					borderLeft: 'none',
					borderTop: 'none',
				}}
			/>
		</Box>
	);
}
